let markers = null;

window.addEventListener('load', function () {
	markers = dataJSON.explorer;
	for (const value of Object.values(markers).flat()) {
		if (typeof value.position === "string") {
			value.position = faireChemin(value.position, value.couleur);
		} else {
			if (value.icone === undefined) value.icone = {titre: "default", classe: "fa-solid fa-map-marker-alt"};
			value.position = L.marker(value.position, {icon: faireIcone(value.icone.titre, value.icone.classe)});
		}
	}

	init_select_all_buttons();
	init_map();
});


function faireIcone(titre, classe) {
	return L.divIcon({
		html: `<i class="${classe} fa-fw" style="color: var(--couleur-secondary); font-size: var(--sous-titre);" title="${titre}"></i>`,
		className: "transparent-icon",
		iconSize: [30, 30],
		iconAnchor: [15, 15],
		popupAnchor: [2, -15]
	});
}

function faireChemin(dir, color) {
	if (color === undefined) color = 'blue';
	if (dir.endsWith('.geojson')) {
		const request = new XMLHttpRequest();
		request.open("GET", "../../resources/geojson/" + dir, false);
		request.send(null)
		const my_JSON_object = JSON.parse(request.responseText);
		return L.geoJSON(my_JSON_object, {
			style: function (feature) {
				return {color: color};
			}
		});
	}
}


function init_select_all_buttons() {
	const zones_selection = document.querySelectorAll(".zone-selection");
	zones_selection.forEach(zone_selection => {
		const buttons = zone_selection.querySelectorAll(".checkbox-total input");
		buttons.forEach(button => {
			button.addEventListener("click", function () {
				/* si 1 cochee et 0 pas cochee : ne pas cocher (length === 0) */
				const cocher = zone_selection.querySelectorAll(":has(.choix .checkbox input:checked):not(:has(.choix .checkbox input:not(:checked))) > .checkbox-total .fa-check-square").length === 0;
				const checkboxes = zone_selection.querySelectorAll(".checkbox input");
				checkboxes.forEach(checkbox => {
					if (checkbox.checked === cocher) return;
					checkbox.checked = cocher;
					checkbox.dispatchEvent(new Event("change"));
				});
			});
		})
	})
}

function init_map() {
	let map = L.map('map', {
		almostOnMouseMove: false,
		// retire le scroll sur mobile avec un doigt
		dragging: true
	}).setView([48.700958, 6.067067], 14);
	L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
		subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
		maxZoom: 20,
	}).addTo(map);

	const checkboxs = document.querySelectorAll(".checkbox input");
	checkboxs.forEach(checkbox => {
		checkbox.addEventListener("change", function () {
			const id = checkbox.id;
			if (!id) return;

			// pour chaque marker, si la checkbox est cochee, on l'ajoute a la map, sinon on le retire
			for (const marker of markers[id]) {
				if (checkbox.checked) {
					if (marker.position._layers) map.almostOver.addLayer(marker.position);
					marker.position.addTo(map);
				} else {
					if (marker.position._layers) map.almostOver.removeLayer(marker.position);
					marker.position.removeFrom(map);
				}
			}
		});
	});

	new ResizeObserver(() => {
		map.invalidateSize();
	}).observe(document.getElementById("map"));

	init_popup(map);
}

function init_popup(map) {
	for (const marker of Object.values(markers).flat()) {
		if (marker.position._layers) {
			map.on("almost:click", (e) => {
				if (e.layer.feature.properties.id !== marker.id) return;
				generate_content(marker);
			});
		} else {
			marker.position.on("click", () => {
				generate_content(marker);
			});
		}
	}

	function generate_content(marker) {
		document.getElementById("carte_description").innerHTML = marker.contenu;
	}
}